import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob('./**/*_controller.*', { eager: true })
registerControllers(application, controllers)

// tabs is registered from ./tabs_controller.js (extends the library Tabs with
// opt-in URL query-param sync); only Modal is registered here.
import { Modal } from "tailwindcss-stimulus-components"
application.register('modal', Modal)

import PasswordVisibility from '@stimulus-components/password-visibility'
application.register('password-visibility', PasswordVisibility)

import Clipboard from '@stimulus-components/clipboard'
application.register('clipboard', Clipboard)